// extracted by mini-css-extract-plugin
export default {"entity_id":"styles_entity_id__dgNiG","icon_wrapper":"styles_icon_wrapper__Qx8vy","notification_content":"styles_notification_content__sdqQe"};